import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { fetchMenuTree as _fetchMenuTree } from "@/api/admin/menu";
export default {
  name: "Management",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      routerList: [],
      defaultActive: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["userData"])),
  created: function created() {
    this.fetchMenuTree();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    addViewRouter: function addViewRouter() {
      var _this = this;

      // console.log(this.userData.routerData,'this.userData.routerData');
      this.routerList = this.routerList.filter(function (val) {
        return _this.userData.routerData.indexOf(val.path) > -1;
      });
      console.log(this.routerList);
      this.defaultActive = this.routerList[0].children[0].path;
      this.$router.push(this.defaultActive);
    },
    fetchMenuTree: function fetchMenuTree() {
      var _this2 = this;

      _fetchMenuTree().then(function (_ref) {
        var data = _ref.data;
        var managementMenu = data.data.find(function (item) {
          return item.id == 1028;
        }).children;
        _this2.routerList = managementMenu;

        _this2.addViewRouter();
      });
    },
    hasItem: function hasItem(path) {
      return this.userData.routerData.includes(path);
    },
    isAdmin: function isAdmin() {
      return (this.userData.roleCodes || []).includes("ROLE_ADMIN");
    }
  },
  watch: {},
  filters: {}
};